import { render, staticRenderFns } from "./blog-9.vue?vue&type=template&id=b234b7d6&scoped=true"
import script from "./blog-9.vue?vue&type=script&lang=js"
export * from "./blog-9.vue?vue&type=script&lang=js"
import style0 from "./blog-9.vue?vue&type=style&index=0&id=b234b7d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b234b7d6",
  null
  
)

export default component.exports